import { useState, useEffect, useContext, useRef } from 'react';
import { BackendContext } from '../../Context/BackendContext.js';
import ArtworkGroup from './ArtworkGroup.js';
import { Spinner } from "@heroui/react";

export default function InventoryArtworks() {
  const backendContext = useContext(BackendContext);
  const { userArtwork, isUserLoading } = backendContext;

  const artworkPages = [...new Set((userArtwork || []).map(artwork => artwork.page))];

  if (isUserLoading) {
    return (
      <>
        <div className="p-6 space-y-16 py-24 text-white text-lg text-center">Loading Artwork...</div>
        <Spinner />
      </>
    );
  }

  if (userArtwork === null) {
    return (
      <div className="p-6 space-y-16 py-24 text-white text-lg text-center">No Owned Artworks</div>
    );
  }

  return (
    <div className="p-6 space-y-12 bg-slate-900">
      {artworkPages.map((page) => (
        <ArtworkGroup 
          key={page} 
          page={page} 
          artwork={userArtwork.filter(artwork => artwork.page === page)} 
        />
      ))}
    </div>
  );
}
  